import { Box, Grid, Skeleton } from "@mui/material";
import { SectionCard } from "./SectionCard";
import { SectionEmptyState } from "./SectionEmptyState";
import { DndContext, closestCenter } from "@dnd-kit/core";
import {
  SortableContext,
  verticalListSortingStrategy,
} from "@dnd-kit/sortable";
import {
  restrictToVerticalAxis,
  restrictToWindowEdges,
  restrictToFirstScrollableAncestor,
} from "@dnd-kit/modifiers";

export const SectionList = ({
  loading,
  filterLoading,
  processedData,
  searchTerm,
  handleModal,
  scrollableRef,
  onDragEnd,
}) => {
  const activeSectionIds = processedData
    .filter(
      (item) => item.FLG_ACTIVO === 1 || item.FLG_ACTIVO === "1"
    )
    .map((item) => item.ID_SECCION);

  return (
    <Box
      ref={scrollableRef}
      sx={{
        p: 2,
        overflowY: "auto",
        flexGrow: 1,
        height: "calc(100vh - 200px)",
        "&::-webkit-scrollbar": { width: "8px" },
        "&::-webkit-scrollbar-track": { backgroundColor: "rgba(0,0,0,0.05)" },
        "&::-webkit-scrollbar-thumb": {
          backgroundColor: "rgba(0,0,0,0.2)",
          borderRadius: "4px",
        },
      }}
    >
      {loading || filterLoading ? (
        <Grid container spacing={2}>
          {[...Array(5)].map((_, i) => (
            <Grid item xs={12} key={i}>
              <Skeleton
                variant="rectangular"
                height={100}
                sx={{ borderRadius: "12px" }}
              />
            </Grid>
          ))}
        </Grid>
      ) : processedData.length === 0 ? (
        <SectionEmptyState
          searchTerm={searchTerm}
          handleModal={handleModal}
        />
      ) : (
        <DndContext
          collisionDetection={closestCenter}
          onDragEnd={onDragEnd}
          modifiers={[
            restrictToVerticalAxis,
            restrictToWindowEdges,
            restrictToFirstScrollableAncestor,
          ]}
        >
          <SortableContext
            items={activeSectionIds}
            strategy={verticalListSortingStrategy}
          >
            <Grid container spacing={2}>
              {processedData.map((item, index) => (
                <SectionCard
                  key={item.ID_SECCION || index}
                  item={item}
                  index={index}
                  handleModal={handleModal}
                />
              ))}
              <Grid item xs={12}>
                <Box sx={{ height: 20 }} />
              </Grid>
            </Grid>
          </SortableContext>
        </DndContext>
      )}
    </Box>
  );
};